// extracted by mini-css-extract-plugin
module.exports = {"inputItem":"addressesDetailsForm_inputItem__-ApJb","address_remove_button_frame":"addressesDetailsForm_address_remove_button_frame__3wthc"};